<script>
import { Line, mixins } from 'vue-chartjs'

export default {
  name: 'Chart',
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['chartData'],

  mounted () {
    this.addPlugin({
      id: 'annotation'
    })

    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      height: 900,
      elements: {
        line: {
          tension: 0 // disables bezier curves
        }
      },
      plugins: [{
        annotation: {
          type: 'line',
          mode: 'vertical',
          value: '2019-03-13',
          label: {
            content: 'Start Anmeldung'
          }
        }
      }]
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/competitions/admin/stats/Chart.vue